module.exports = __webpack_public_path__ + "static/media/marker.2bae08c9.svg";